if ($('.l-innerPage__aside').length) {
    // properties
    var propsAside = {
        el: $('.l-innerPage__aside'),
    };
    var propsContent = {
        el: $('.l-innerPage__aside > .contentIsFixed'),
        height: $('.l-innerPage__aside > .contentIsFixed').height(),
        distanceOfTheTop: $('.l-innerPage__aside > .content').offset().top,
    };
    var propsMain = {
        el: $('.innerPage--withSidebar'),
        navHeight: $('nav').height(),
        scrollEfetuado: $(window).scrollTop(),
        distanceOfTheTop: $('.innerPage--withSidebar').offset().top,
        footerDistance: $('#newsletter').offset().top,
        viewportHeight: $(window).height(),
        viewportWidth: $(window).width(),
    };

    // fixed aside
    function fixedAside() {
        var scrollEfetuado = $(window).scrollTop();

        // unmake fixed content
        if (propsContent.height >= propsMain.viewportHeight - propsMain.navHeight) {
            $('.l-innerPage__aside > .contentIsFixed').removeClass('contentIsFixed');
        }

        // make a fixed content
        if (scrollEfetuado > propsContent.distanceOfTheTop - propsMain.navHeight) {
            propsContent.el.removeClass('topImportant');
            propsContent.el.css('top', scrollEfetuado - (propsContent.distanceOfTheTop - propsMain.navHeight) + 40);
            if ($('nav').hasClass('defaultNav--hide') && $('nav').hasClass('defaultNav--middle')) {
                propsContent.el.css('margin-top', (propsMain.navHeight * -1) + 40);
            } else {
                propsContent.el.css('margin-top', '0');
            }
        } else {
            propsContent.el.addClass('topImportant');
        }

        // Stop fixed content
        if ((propsMain.footerDistance - scrollEfetuado) > propsContent.height + 170) {
            propsContent.el.removeClass('breakContent');
        } else {
            propsContent.el.addClass('breakContent');
        }
    }
    $(window).on('scroll', function() {fixedAside();});
    $(window).on('resize', function() {fixedAside();});

    // link to top
    $('.goToTop a').on('click', function(event) {
         event.preventDefault();
        goToSection__scroll('.innerPage', 100);
    });

    // responsive sub menu
    $('.c-asideInnerPage__widget h3').on('click', function() {
        if (propsMain.viewportWidth <= 650) {
            $(this).parent().children('ul').toggle();
            $(this).parent().toggleClass('is-active--responsive');
        }
    });
}

// scroll links in aside content
$('.l-innerPage__aside .scrollLink, #defaultNav .scrollLink').on('click', function(event) {
    event.preventDefault();
    var scrollDestiny = $(this).attr('href');
    goToSection__scroll(scrollDestiny, 120);
});

if ($('#page_institucional').length) {
    var swiper__institucional__videos = new Swiper('.swiper__institucional__videos', {
        speed: 500,
        spaceBetween: 0,
        autoplay: false
    });
    $('#institucional__videos aside a').on('click', function() {
        $('#institucional__videos aside a').removeClass('is-active');
        $(this).addClass('is-active');
        swiper__institucional__videos.slideTo($(this).attr('data-swiper'));
    });
}

if ($('#page_tecnologias').length) {
    var swiper__tecnologias = new Swiper('.swiper__tecnologias', {
        speed: 500,
        spaceBetween: 60,
        autoplay: false,
        slideToClickedSlide: true,
        autoHeight: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
}

if ($('#page_noticias').length) {
    var swiper__noticias = new Swiper('.swiper__noticias', {
        speed: 500,
        spaceBetween: 30,
        slidesPerView: 3,
        initialSlide: 0,
        autoHeight: false,
        loop: true,
        autoplay: {
            delay: 450000,
        },
        slideToClickedSlide: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            630: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            990: {
                slidesPerView: 2,
                spaceBetween: 20,
            }
        }
    });
}

if ($('#carreiras__vagas').length) {
    function slideActiveOnHash() {
        var dataHash = window.location.hash;
        $('.vagas__cidades a').removeClass('is-active');
        $('.vagas__cidades a[href="'+dataHash+'"]').addClass('is-active');
        var ifDataHash = dataHash.split('_');
        if (ifDataHash[0] != '#vagas') {
            $('.vagas__cidades a').removeClass('is-active');
            $('.vagas__cidades ul li:first-of-type a').addClass('is-active');
        }
    }
    function updateHeightSwiper() {
        setTimeout(function() {
            swiper__vagas.updateAutoHeight(500);
        }, 200);
    }

    slideActiveOnHash();
    /*var swiper__vagas = new Swiper('.swiper__vagas', {
        speed: 500,
        spaceBetween: 0,
        autoplay: false,
        hashNavigation: {
            replaceState: true,
            watchState: true,
        },
    });*/
    $('.c-tabMenuItem .vaga__title').on('click', function() {
        $(this).parent().toggleClass('is-active');
        updateHeightSwiper();
    });
    $('.vagas__cidades a').on('click', function() {
        $('.vagas__cidades a').removeClass('is-active');
        $(this).addClass('is-active');
        goToSection__scroll('.vagas__content', 80);
        updateHeightSwiper();
    });
}

if ($('#carreiras__inscricao').length) {
    // anexo de arquivos
    $('.fileInput--cv .iptFile').on('change', function() {
        var nameFile = $(this).val().split("fakepath");
        $('.fileInput--cv .fakeInputFile').val(nameFile[1]);
        if(nameFile.length > 1){
            $('.fileInput--cv .fakeInputFile').removeClass('error');
        }else{
            $('.fileInput--cv .fakeInputFile').addClass('error');
        }
    });
    $('.fileInput--ft .iptFile').on('change', function() {
        var nameFile = $(this).val().split("fakepath");
        $('.fileInput--ft .fakeInputFile').val(nameFile[1]);
    });
    // btn para selecionar vaga
    $('.obsVaga').on('click', function() {
        goToSection__scroll('#carreiras__vagas', 155);
    });
    $('#carreiras__vagas .vagas__content .c-btn').on('click', function(event) {
        event.preventDefault();
        goToSection__scroll('#carreiras__inscricao', 60);
        var nameJob = $(this).parent().parent().children('.vaga__title').children('h3').html();
        var codJob = $(this).attr('data-codigo');
        $('.selectedJob input').val(nameJob);
        $('#codJob').val(codJob);
        $('.obsVaga').hide();
    });

    // checked inputs on click in box
    $('.box__radioAndCheck').on('click', function() {
        var checkbox = $(this).children('input');
        checkbox.prop('checked', true);
        $(this).parent().children('.box_radio').removeClass('is-checked');
        $(this).toggleClass('is-checked');
    });

    $('.box__onlyCheck').on('click', function() {
        var checkbox = $(this).children('input');
        console.log('check div');
        if($(this).hasClass('is-checked')){
            checkbox.prop('checked', false);
            $(this).removeClass('is-checked');
        }else{
            checkbox.prop('checked', true);
            $(this).addClass('is-checked');
        }
    });

    $('.checkPrimeiroEmprego').on('click', function() {
        var checkbox = $(this).children('input');
        if(checkbox.val() === 'N'){
            $('#experienciasContent').show();
        }else{
            $('#experienciasContent').hide();
        }
    });

    $('#btnAddExperiencia').on('click', function(e) {
        e.preventDefault();
        var conteudo = $('.cloneExperiencia').html();
        $('.experienciasIn').append(conteudo);
        $('.dataMask').mask("99/99/9999");
    });

    $(document).on('click','.btnDeleteExperiencia', function(e) {
        e.preventDefault();
        $(this).parent().parent().remove();
    });
}
$(window).on('load', function() {
    if ($('.l-noticias__sidebar').length) {
        var swiper__gasometro = new Swiper('.swiper__gasometro', {
            speed: 500,
            spaceBetween: 60,
            autoplay: false,
            autoHeight: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    }
});

if ($('.post__content').length) {
    $(document).ready(function(){
        $(".post__content iframe").removeAttr('width').removeAttr('height');
        $(".post__content iframe").wrap('<div class="u-aspectRatio u-aspectRatio--16-9" />');
        var i = 1;
        $('.gallery').each(function(){
            var Gallery = $(this);
            var htmlGallery ='';
            Gallery.removeAttr('id').addClass('grid__post u-flexContainer');
            Gallery.find('a').each(function(){
                var href = $(this).attr('href');
                var src = $(this).children('img').attr('src');
                htmlGallery += '<a href="'+href+'" title="Posts" data-fancybox="grid_post_'+i+'"><figure class="u-aspectRatio u-aspectRatio--4-3"><img src="'+src+'" alt="Posts"></figure></a>';
            });
            i++;
            Gallery.empty();
            Gallery.append(htmlGallery);
        });
    });
}

if ($('#contentUnit').length) {
    $(document).ready(function(){
        goToSection__scroll('main', 100, 0);
    });
}
if ($('#contentVagas').length) {
    $(document).ready(function(){
        goToSection__scroll('#carreiras__vagas', 0);
    });
}

$('.foneMask').focusout(function () {
    var phone, element;
    element = $(this);
    element.unmask();
    phone = element.val().replace(/\D/g, '');
    if (phone.length > 10) {
        element.mask("(99) 99999-999?9");
    } else {
        element.mask("(99) 9999-9999?9");
    }
}).trigger('focusout');

$('.dataMask').mask("99/99/9999");
$('.cpfMask').mask("999.999.999-99");
$('.cepMask').mask("99999-999");

function TestaCPF(CPF) {
    var erro = 0;
    var Soma;
    var Resto;
    var strCPF = CPF.replace(".", ""); //tira ponto
    strCPF = strCPF.replace(".", ""); //tira o segundo ponto
    strCPF = strCPF.replace("-", ""); //tira hífen

    Soma = 0;
    if (strCPF == "00000000000") erro = 1;

    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) erro = 1;

    Soma = 0;
    for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) erro = 1;

    if (erro == 0) {
        return true;
    } else {
        return false;
    }
}




if ($('.formPages').length) {
    $("#formContato").validate({
        submitHandler: function (form) {

            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    Swal.fire({
                        title: 'Enviando mensagem, aguarde...',
                        showConfirmButton: false,
                        onBeforeOpen: function() {
                            Swal.showLoading();
                        }
                    });
                    $('#btnContato').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                        Swal.fire({
                            type: 'success',
                            title: 'Mensagem enviada com sucesso!',
                            showConfirmButton: false,
                            timer: 2000,
                            onClose: function() {
                                setTimeout(function(){
                                    $('#btnContato').attr('disabled',false);
                                    $("#formContato .field").val('');
                                    $("#formContato textarea").val('').html('');
                                    $("#formContato .field").removeClass('error');
                                },500);
                            }
                        });
                    }else{
                        Swal.fire({
                            type: 'error',
                            title: 'Atenção!',
                            text: result,
                            showConfirmButton: false,
                            timer: 3000,
                            onClose: function() {
                                setTimeout(function(){
                                    $('#btnContato').attr('disabled', false);
                                },500);
                            }
                        });
                    }
                }
            });
        }
    });

    $(document).on('change','#formCotacao #estado',function(e) {
        e.preventDefault();
        var uf = $(this).val();
        if ($(this).val() != '') {
            $.ajax({
                type: "POST",
                url: "ajax-cidades.php",
                data: 'uf=' + uf,
                success: function(result) {
                    $('#formCotacao #cidade').html(result);
                }
            });
        } else {
            $('#formCotacao #cidade').html('<option value="" disabled selected>Aguardando estado...</option>');
        }
    });


    $("#formCotacao").validate({
        submitHandler: function (form) {
            var isChecked = false;
            $('.box__onlyCheck input').each(function(){
                 if($(this).prop("checked")){
                     isChecked = true;
                 }
            });

            if (isChecked) {
                $(form).ajaxSubmit({
                    //target: 'status-envio',
                    beforeSubmit: function () {
                        Swal.fire({
                            title: 'Enviando mensagem, aguarde...',
                            showConfirmButton: false,
                            onBeforeOpen: function () {
                                Swal.showLoading();
                            }
                        });
                        $('#btnEnviaCV').attr('disabled', true);
                    },
                    success: function (result) {
                        result = result.split('|');
                        if (parseInt(result[0].charAt(result[0].length - 1)) == 1) {
                            Swal.fire({
                                type: 'success',
                                title: 'Cotação enviada com sucesso!',
                                showConfirmButton: false,
                                timer: 2000,
                                onClose: function () {
                                    setTimeout(function () {
                                        $('#btnEnviaCotacao').attr('disabled', false);
                                        $("#formCotacao .field").val('').html('');
                                        $("#formCotacao .field").removeClass('error');
                                        $('.box__onlyCheck').removeClass('is-checked');
                                        $('.box__onlyCheck input').prop('checked',false);
                                        $('.box__quantidade').removeClass('is-active');
                                        $('.box__quantidade').children('input').prop("disabled", true);
                                    }, 500);
                                }
                            });
                        } else {
                            Swal.fire({
                                type: 'error',
                                title: 'Atenção!',
                                text: result,
                                showConfirmButton: false,
                                timer: 3000,
                                onClose: function () {
                                    setTimeout(function () {
                                        $('#btnEnviaCotacao').attr('disabled', false);
                                    }, 500);
                                }
                            });
                        }
                    }
                });
            }else{
                Swal.fire({
                    type: 'error',
                    title: 'Atenção!',
                    text: 'Selecione um ou mais produtos!',
                    showConfirmButton: false,
                    timer: 3000,
                    onClose: function () {
                        setTimeout(function () {
                            $('#btnEnviaCotacao').attr('disabled', false);
                        }, 500);
                    }
                });
            }
        }
    });


    $(document).on('change','#formCurriculo #estado',function(e) {
        e.preventDefault();
        var uf = $(this).val();
        if ($(this).val() != '') {
            $.ajax({
                type: "POST",
                url: "ajax-cidades.php",
                data: 'uf=' + uf,
                success: function(result) {
                    $('#formCurriculo #cidade').html(result);
                }
            });
        } else {
            $('#formCurriculo #cidade').html('<option value="" disabled selected>Aguardando estado...</option>');
        }
    });

    $("#formCurriculo").validate({
        rules: {
            login_confirma_senha: {
                equalTo: "#login_senha"
            }
        },
        messages: {
            login_confirma_senha: {
                equalTo: "As senhas estão diferentes."
            }
        },
        submitHandler: function (form) {
            if (TestaCPF($('#cpf').val())) {
                $(form).ajaxSubmit({
                    //target: 'status-envio',
                    beforeSubmit: function () {
                        Swal.fire({
                            title: 'Enviando mensagem, aguarde...',
                            showConfirmButton: false,
                            onBeforeOpen: function () {
                                Swal.showLoading();
                            }
                        });
                        $('#btnEnviaCV').attr('disabled', true);
                    },
                    success: function (result) {
                        result = result.split('|');
                        if (parseInt(result[0].charAt(result[0].length - 1)) == 1) {
                            Swal.fire({
                                type: 'success',
                                title: 'Mensagem enviada com sucesso!',
                                showConfirmButton: false,
                                timer: 2000,
                                onClose: function () {
                                    setTimeout(function () {
                                        $('#btnEnviaCV').attr('disabled', false);
                                        /*$("#formCurriculo .field").val('').html('');
                                        $("#formCurriculo .field").removeClass('error');
                                        $('.box__radioAndCheck,.box__onlyCheck').removeClass('is-checked');
                                        $('.box__radioAndCheck input,.box__onlyCheck input').prop('checked',false);
                                        $('.fileInput--cv .fakeInputFile').val('');
                                        $('.fileInput--ft .fakeInputFile').val('');*/
                                        location.href = 'carreiras-cv';
                                    }, 500);
                                }
                            });
                        } else {
                            Swal.fire({
                                type: 'error',
                                title: 'Atenção!',
                                text: result,
                                showConfirmButton: false,
                                timer: 3000,
                                onClose: function () {
                                    setTimeout(function () {
                                        $('#btnEnviaCV').attr('disabled', false);
                                    }, 500);
                                }
                            });
                        }
                    }
                });
            }else{
                Swal.fire({
                    type: 'error',
                    title: 'Atenção!',
                    text: 'CPF Inválido!',
                    showConfirmButton: false,
                    timer: 3000,
                    onClose: function () {
                        setTimeout(function () {
                            $('#btnEnviaCV').attr('disabled', false);
                            $('#cpf').focus();
                        }, 500);
                    }
                });
            }
        }
    });

    $("#formCadastro").validate({
        submitHandler: function (form) {
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    Swal.fire({
                        title: 'Enviando, aguarde...',
                        showConfirmButton: false,
                        onBeforeOpen: function () {
                            Swal.showLoading();
                        }
                    });
                    $('#btnCadastro').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0].charAt(result[0].length - 1)) == 1) {
                        Swal.fire({
                            type: 'success',
                            title: 'Email ok! Redirecionando...',
                            showConfirmButton: false,
                            timer: 2000,
                            onClose: function () {
                                setTimeout(function () {
                                    $('#btnCadastro').attr('disabled', false);
                                    location.href = 'carreiras-cv';
                                }, 500);
                            }
                        });
                    } else {
                        Swal.fire({
                            type: 'error',
                            title: 'Atenção!',
                            text: result,
                            showConfirmButton: false,
                            timer: 5000,
                            onClose: function () {
                                setTimeout(function () {
                                    $('#btnCadastro').attr('disabled', false);
                                }, 500);
                            }
                        });
                    }
                }
            });
        }
    });

    $("#formLogin").validate({
        submitHandler: function (form) {
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    Swal.fire({
                        title: 'Enviando, aguarde...',
                        showConfirmButton: false,
                        onBeforeOpen: function () {
                            Swal.showLoading();
                        }
                    });
                    $('#btnLogin').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0].charAt(result[0].length - 1)) == 1) {
                        Swal.fire({
                            type: 'success',
                            title: result[1],
                            text: result[2],
                            showConfirmButton: false,
                            timer: 5000,
                            onClose: function () {
                                setTimeout(function () {
                                    $('#btnLogin').attr('disabled', false);
                                    location.href = 'carreiras-cv';
                                }, 500);
                            }
                        });
                    } else {
                        Swal.fire({
                            type: 'error',
                            title: result[0],
                            text: result[1],
                            showConfirmButton: false,
                            timer: 5000,
                            onClose: function () {
                                setTimeout(function () {
                                    $('#btnLogin').attr('disabled', false);
                                }, 500);
                            }
                        });
                    }
                }
            });
        }
    });

    $("#formSenha").validate({
        rules: {
            passTwo: {
                equalTo: "#passOne"
            }
        },
        messages: {
            passTwo: {
                equalTo: "As senhas estão diferentes."
            }
        },
        submitHandler: function (form) {
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    Swal.fire({
                        title: 'Enviando, aguarde...',
                        showConfirmButton: false,
                        onBeforeOpen: function () {
                            Swal.showLoading();
                        }
                    });
                    $('#btnSenha').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0].charAt(result[0].length - 1)) == 1) {
                        Swal.fire({
                            type: 'success',
                            title: result[1],
                            text: result[2],
                            showConfirmButton: false,
                            timer: 5000,
                            onClose: function () {
                                setTimeout(function () {
                                    $('#btnSenha').attr('disabled', false);
                                    location.href = 'carreiras-cv';
                                }, 500);
                            }
                        });
                    } else {
                        Swal.fire({
                            type: 'error',
                            title: result[0],
                            text: result[1],
                            showConfirmButton: false,
                            timer: 5000,
                            onClose: function () {
                                setTimeout(function () {
                                    $('#btnSenha').attr('disabled', false);
                                }, 500);
                            }
                        });
                    }
                }
            });
        }
    });

    $(document).on('click', '.cardlogin .back', function(){
        $(this).hide();
        $('#sendPass').val('N');
        $('#formLogin .buttonLi').removeClass('fw_60p').addClass('fw_100p');
        $('#formLogin .emailField').removeClass('fw_60p').addClass('fw_50p');
        $('#formLogin .buttonLi button').html('Entrar');
        $('.passField').show();
    });

    $(document).on('click', '.cardlogin .forgot', function(){
        $('.cardlogin .back').show();
        $('#sendPass').val('S');
        $('#formLogin .buttonLi').removeClass('fw_100p').addClass('fw_60p');
        $('#formLogin .emailField').removeClass('fw_50p').addClass('fw_60p');
        $('#formLogin .buttonLi button').html('Enviar');
        $('.passField').hide();
    });


    /*$(document).on('blur','#cpf', function(){
        var cpf = $(this).val();
        $.ajax({
            type: "POST",
            url: "ajax-cpf.php",
            data: 'cpf=' +cpf,
            success: function(result){
                //console.log(result)
                var array = result.split('|');
                if (array[0] == 'S'){
                    $('#formRH__dadosPessoais__nome').val(array[1]);
                    $('#formRH__dadosPessoais__sexo option[value="'+array[2]+'"]').attr('selected', true);
                    $('#formRH__dadosPessoais__dataNasc').val(array[3]);
                    $('#formRH__dadosPessoais__naturalidade').val(array[4]);
                    $('#formRH__dadosPessoais__estadoCivil option[value="'+array[5]+'"]').attr('selected', true);
                    $('#formRH__dadosPessoais__filhos option[value="'+array[6]+'"]').attr('selected', true);
                    $('#formRH__dadosPessoais__pai').val(array[7]);
                    $('#formRH__dadosPessoais__mae').val(array[8]);
                    $('#formRH__dadosPessoais__conjuge').val(array[9]);
                    $('#formRH__localizacao__endereco').val(array[10]);
                    $('#formRH__localizacao__cep').val(array[11]);
                    $('#estado option[value="'+array[12]+'"]').attr('selected',true);
                    $('#cidade').html('<option value="'+array[48]+'">'+array[13]+'</option>');
                    $('#formRH__localizacao__bairro').val(array[14]);
                    var disponibilidade = array[15].split(',');
                    for(var i =0; i < disponibilidade.length; i++ ) {
                        var value = disponibilidade[i].trim();
                        $('input[name="formRH__dadosComplementares__disponibilidade[]"][value="'+value+'"]').prop('checked', true);
                        $('input[name="formRH__dadosComplementares__disponibilidade[]"][value="'+value+'"]').parent().addClass('is-checked');
                    }
                    var cnh = array[16].split(',');
                    for(var a =0; a < cnh.length; a++ ) {
                        var value2 = cnh[a].trim();
                        $('input[name="formRH__dadosComplementares__cnh[]"][value="'+value2+'"]').prop('checked', true);
                        $('input[name="formRH__dadosComplementares__cnh[]"][value="'+value2+'"]').parent().addClass('is-checked');
                    }
                    $('#formRH__dadosPessoais__email').val(array[17]);
                    $('#formRH__dadosPessoais__telefone').val(array[18]);
                    $('#formRH__dadosPessoais__celular').val(array[19]);
                    $('#formRH__dadosPessoais__rg').val(array[20]);
                    $('input[name=formRH__dadosComplementares__possuiMoto][value="' + array[21] + '"]').prop('checked', true);
                    $('input[name=formRH__dadosComplementares__possuiMoto][value="' + array[21] + '"]').parent().addClass('is-checked');
                    $('input[name=formRH__dadosComplementares__possuiCarro][value="' + array[22] + '"]').prop('checked', true);
                    $('input[name=formRH__dadosComplementares__possuiCarro][value="' + array[22] + '"]').parent().addClass('is-checked');
                    $('input[name=formRH__dadosComplementares__jaTrabalhou][value="' + array[23] + '"]').prop('checked', true);
                    $('input[name=formRH__dadosComplementares__jaTrabalhou][value="' + array[23] + '"]').parent().addClass('is-checked');
                    $('#formRH__dadosComplementares__escolaridade option[value="'+array[24]+'"]').attr('selected',true);
                    $('#formRH__dadosComplementares__cursos option[value="'+array[25]+'"]').attr('selected',true);
                    $('#formRH__dadosComplementares__outrosCursos').val(array[26]);
                    $('#formRH__experienciasProfissionais__1__nomeEmpresa').val(array[27]);
                    $('#formRH__experienciasProfissionais__1__cargo').val(array[28]);
                    $('#formRH__experienciasProfissionais__1__motivo').val(array[29]);
                    $('#formRH__experienciasProfissionais__1__admissao').val(array[30]);
                    $('#formRH__experienciasProfissionais__1__demissao').val(array[31]);
                    $('#formRH__experienciasProfissionais__2__nomeEmpresa').val(array[32]);
                    $('#formRH__experienciasProfissionais__2__cargo').val(array[33]);
                    $('#formRH__experienciasProfissionais__2__motivo').val(array[34]);
                    $('#formRH__experienciasProfissionais__2__admissao').val(array[35]);
                    $('#formRH__experienciasProfissionais__2__demissao').val(array[36]);
                    $('#formRH__experienciasProfissionais__3__nomeEmpresa').val(array[37]);
                    $('#formRH__experienciasProfissionais__3__cargo').val(array[38]);
                    $('#formRH__experienciasProfissionais__3__motivo').val(array[39]);
                    $('#formRH__experienciasProfissionais__3__admissao').val(array[40]);
                    $('#formRH__experienciasProfissionais__3__demissao').val(array[41]);
                    $('#formRH__experienciasProfissionais__outrasAtividades').val(array[42]);
                    $('#formRH__localizacao__numero').val(array[43]);
                    $('#formRH__localizacao__complemento').val(array[44]);
                    $('input[name=formRH__dadosComplementares__deficiencia][value="' + array[45] + '"]').prop('checked', true);
                    $('input[name=formRH__dadosComplementares__deficiencia][value="' + array[45] + '"]').parent().addClass('is-checked');
                    $('#data_cadastro').val(array[46]);
                    $('#img_update').val(array[49]);// [48] ENTRE [12] E [14]
                    $('#anexo_update').val(array[50]);// [48] ENTRE [12] E [14]
                    $('input[name=formRH__dadosComplementares__fumante][value="' + array[51] + '"]').prop('checked', true);
                    $('input[name=formRH__dadosComplementares__fumante][value="' + array[51] + '"]').parent().addClass('is-checked');
                    $('#formRH__conhecido__nome').val(array[52]);
                    $('#formRH__conhecido__setor').val(array[53]);

                    $("#formCurriculo .field").removeClass('error');
                    $("#formCurriculo #insert_update").val('form-update');
                    $("#formCurriculo #cod_update").val($("#formCurriculo #cpf").val());
                }else{
                    //$("#formCurriculo .field").val('');
                    //$("#formCurriculo .field").blur();
                    $("#formCurriculo #insert_update").val('form_cur');
                    $("#formCurriculo #cod_update").val('');

                    //console.log('blur: ', blur());

                    $("#formCurriculo .field").removeClass('error');
                }
            }
        });
    });*/
}

if ($('#flipbook').length) {
    var orientacao = $('#flipbook').attr('data-orientacao');
    var size_width  = 1094;
    var size_height = 390;
    if (orientacao == 'V') {
        size_width  = 1094;
        size_height = 776;
    }

    $("#flipbook").turn({
        autoCenter: false,
        width: size_width,
        height: size_height
    })
    $('.flipBookArrow-next').on('click', function() {$("#flipbook").turn("next");})
    $('.flipBookArrow-prev').on('click', function() {$("#flipbook").turn("previous");})
}

if($('#page_cotacao').length) {
    $('.box__onlyCheck').on('click', function() {
        if ($(this).hasClass('is-checked')) {
            $(this).parent().children('.box__quantidade').addClass('is-active');
            $(this).parent().children('.box__quantidade').children('input').prop("disabled", false);
        } else {
            $(this).parent().children('.box__quantidade').removeClass('is-active');
            $(this).parent().children('.box__quantidade').children('input').prop("disabled", true).val('');
//            $(this).parent().children('.box__quantidade').children('input').val('');
        }
    });
}
